import React, { useEffect,useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { LOGIN_SUCCESS } from '../constants/userConstants';
import { useDispatch } from 'react-redux';
import "./VerifyUser.css";

export const VerifyUser = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: LOGIN_SUCCESS, payload: state });
    localStorage.setItem("nftuser", JSON.stringify({ ...state, password: "", expire: new Date().getDate() + 7 }));
  }, []);
  const RedirectCountdown = ({ initialSeconds }) => {
    const [seconds, setSeconds] = useState(initialSeconds);
  
    useEffect(() => {
      if (seconds <= 0) {
        const userData = JSON.parse(localStorage.getItem("nftuser"));
        if(!userData) {
          navigate('/login');
        } else if(!userData?.overwolf) {
          navigate('/post-registration');
        } else if (userData?.available_fund <= 0 && userData?.bonus_fund <= 0) {
          navigate('/registration-deposit');
        } else {
          navigate('/SoloShowdown');
        }
      }

      const interval = setInterval(() => {
        setSeconds(prev => prev - 1);
      }, 1000);
  
      return () => clearInterval(interval);
    }, [seconds]);
  
    return <div style={{ display: 'inline' }}> {seconds > 0 ? `Redirecting in: ${seconds}` : "Redirecting..."} </div>;
  };

  return (
    <div className='body-main'>
      <div className='thank-sec'>
        <div className='thnkct'>
          <h2 style={{ marginBottom: '15px'}}>Thank you for verifying your email!</h2>
          <h4 style={{ marginBottom: '25px'}}>You are now able to start sending challenges!</h4>
          <h4 className='redirect-label'>
            <CircularProgress size={12} style={{marginRight: '5px'}}/>
            <RedirectCountdown initialSeconds={7} />
            </h4>
        </div>
        </div>
    </div>
  )
}

export default VerifyUser;
